const componentTransPath = 'button.';

const translations = {
    NEXT_BTN_LABEL: componentTransPath + "next",
};

export default translations;